<template>
  <div>
    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card" :before-leave="beforeTabLeave">
      <el-tab-pane label="用户列表" name="first">
        <div class="main">
          <!-- Right -->
          <div class="main_r">
            <!-- search -->
            <div class="search">
              <div>
                <el-input v-model="queryData.account"  placeholder="请输入账号"></el-input>
                <el-input v-model="queryData.nickName"  placeholder="请输入昵称"></el-input>
                <el-input v-model="queryData.slogan"  placeholder="请输入口号"></el-input>
                <el-select v-model="queryData.sex" placeholder="性别">
                  <el-option label="请选择性别" value="0"></el-option>
                  <el-option label="男" value="1"></el-option>
                  <el-option label="女" value="2"></el-option>
                  <el-option label="保密" value="3"></el-option>
                </el-select>
                <el-button type="primary" @click="clickQuery">查询</el-button>
                <el-button type="primary" @click="clickQueryReset" plain>重置</el-button>
                <el-button type="primary" @click="clickNoticeSelect">通知勾选用户</el-button>
                <el-button type="primary" @click="clickNoticeAll">通知所有用户</el-button>
              </div>
            </div>
            <!-- search End -->

            <!-- 列表 -->
            <el-table :data="dataList" class="mt15" :header-cell-style="{textAlign: 'center'}" :cell-style="{ textAlign: 'center' }" @selection-change="handleSelectionChange">
              <el-table-column type="selection" width="55"></el-table-column>
              <el-table-column prop="id" label="序号" min-width="5%"></el-table-column>
              <el-table-column prop="account" label="账号" min-width="15%"></el-table-column>
              <el-table-column prop="nickName" label="昵称" min-width="15%"></el-table-column>
              <el-table-column prop="" label="微信头像" min-width="15%">
                <template v-slot="scope">
                  <img :src="scope.row.headimgurl" min-width="64" height="64" />
                </template>
              </el-table-column>
<!--              <el-table-column prop="height" label="身高"></el-table-column>
              <el-table-column prop="weight" label="体重"></el-table-column>
              <el-table-column prop="age" label="年龄"></el-table-column>
              <el-table-column prop="userStatus" label="性别">
                <template slot-scope="props">
                  <span v-if="props.row.sex == 1">男</span>
                  <span v-if="props.row.sex == 2">女</span>
                  <span v-if="props.row.sex == 3">保密</span>
                </template>
              </el-table-column>
              <el-table-column prop="birthday" label="生日"></el-table-column>
              <el-table-column prop="slogan" label="口号"></el-table-column> -->
              <el-table-column prop="lastLoginTime" label="最后登录时间" min-width="15%"></el-table-column>
              <el-table-column prop="createTime" label="创建时间" min-width="15%"></el-table-column>
              <el-table-column prop="Operation" label="操作" min-width="20%">
                <template slot-scope="props">
                  <el-tooltip class="item" effect="dark" content="编辑" placement="top" :enterable="false">
                    <el-link :underline="false" type="primary" icon="el-icon-edit" class="mr12" @click="clickdialogEdit(props.row)"></el-link>
                  </el-tooltip>
                  <el-tooltip class="item" effect="dark" content="体脂秤数据" placement="top" :enterable="false">
                    <el-link :underline="false" type="primary" icon="el-icon-odometer" class="mr12" @click="gotoWebBodyFatScalesLog(props.row)"></el-link>
                  </el-tooltip>
                  <el-tooltip class="item" effect="dark" content="训练报告" placement="top" :enterable="false">
                    <el-link :underline="false" type="primary" icon="el-icon-s-data" class="mr12" @click="gotoWebTwoTrainReport(props.row)"></el-link>
                  </el-tooltip>
                  <el-tooltip class="item" effect="dark" content="我的训练计划" placement="top" :enterable="false">
                    <el-link :underline="false" type="primary" icon="el-icon-s-check" class="mr12" @click="gotoWebTwoTrainPlanMy(props.row)"></el-link>
                  </el-tooltip>
                  <el-tooltip class="item" effect="dark" content="通知单个用户" placement="top" :enterable="false">
                    <el-link :underline="false" type="primary" icon="el-icon-notebook-2" class="mr12" @click="clickdialogNotice(props.row)"></el-link>
                  </el-tooltip>
                </template>
              </el-table-column>
            </el-table>

            <!-- 分页 -->
            <div class="mt20">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="page_no"
                :page-sizes="[5, 10, 15, 20]"
                :page-size="page_size"
                layout="prev, pager, next, sizes, jumper "
                :total="dataListnum">
              </el-pagination>
            </div>
            <!-- 分页 End -->
          </div>
          <!-- Right End -->

          <!-- 编辑信息 -->
          <el-dialog title="编辑信息" :visible.sync="dialogEdit" width="26%" class="newAdd">
            <div class="addUser_body">
              <el-form ref="userMsg" :model="editData" label-width="80px">
                <el-form-item label="昵称">
                  <el-input v-model="editData.nickName" placeholder="请输入昵称"></el-input>
                </el-form-item>
                <el-form-item label="微信头像" :required=true>
                  <el-input v-model="editData.headimgurl" placeholder="请输入微信头像"></el-input>
                </el-form-item>
                <el-form-item label="身高" :required=true>
                  <el-input v-model="editData.height" placeholder="请输入身高">
                    <template slot="append">
                      <span style="width: 100px; display: inline-block;text-align: center;">cm</span>
                    </template>
                  </el-input>
                </el-form-item>
                <el-form-item label="体重" :required=true>
                  <el-input v-model="editData.weight" placeholder="请输入体重">
                    <template slot="append">
                      <span style="width: 100px; display: inline-block;text-align: center;">Kg</span>
                    </template>
                  </el-input>
                </el-form-item>
                <el-form-item label="年龄" :required=true>
                  <el-input v-model="editData.age" placeholder="请输入年龄">
                    <template slot="append">
                      <span style="width: 100px; display: inline-block;text-align: center;">岁</span>
                    </template>
                  </el-input>
                </el-form-item>
                <el-form-item label="性别">
                  <el-select v-model="editData.sex" placeholder="性别">
                    <el-option label="男" value="1"></el-option>
                    <el-option label="女" value="2"></el-option>
                    <el-option label="保密" value="3"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="生日" :required=true>
                  <el-input v-model="editData.birthday" placeholder="请输入生日"></el-input>
                </el-form-item>
                <el-form-item label="口号" :required=true>
                  <el-input v-model="editData.slogan" placeholder="请输入口号"></el-input>
                </el-form-item>
              </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
              <el-button type="primary" @click="TerminalUserEdit()" >确 认</el-button>
              <el-button @click="dialogEdit = false">取 消</el-button>
            </div>
          </el-dialog>
          <!-- 编辑信息 End -->

        </div>
      </el-tab-pane>

      <!-- 体脂秤数据 start -->
      <el-tab-pane label="体脂秤数据" name="four">
        <WebBodyFatScalesLog ref="SubVuefour" v-on:triggerFunc="BackToFirst"></WebBodyFatScalesLog>
      </el-tab-pane>
      <!-- 体脂秤数据 end -->

      <!-- 训练报告 start -->
      <el-tab-pane label="训练报告" name="six">
        <WebTwoTrainReport ref="SubVuesix" v-on:triggerFunc="BackToFirst"></WebTwoTrainReport>
      </el-tab-pane>
      <!-- 训练报告 end -->

      <!-- 我的训练计划 start -->
      <el-tab-pane label="我的训练计划" name="seven">
        <WebTwoTrainPlanMy ref="SubVueseven" v-on:triggerFunc="BackToFirst"></WebTwoTrainPlanMy>
      </el-tab-pane>
      <!-- 我的训练计划 end -->

      <!-- 通知列表 start -->
      <el-tab-pane label="通知列表" name="five">
        <WebTwoNoticeNeedRead ref="SubVuefive" v-on:triggerFunc="BackToFirst"></WebTwoNoticeNeedRead>
      </el-tab-pane>
      <!-- 通知列表 end -->

    </el-tabs>
    <!-- Tabs end -->

    <!-- 发送通知 -->
    <el-dialog :title="dialogNoticeTitle" :visible.sync="dialogNotice" width="80%" class="newAdd">
      <div class="main">
        <!-- Right -->
        <div class="main_r">
          <!-- search -->
          <div class="search">
            <div>
              <el-select v-model="queryDataNotice.noticeType" placeholder="消息类型">
                <el-option label="请选择消息类型" value="0"></el-option>
                <el-option label="系统消息" value="1"></el-option>
                <el-option label="活动消息" value="2"></el-option>
              </el-select>
              <el-input v-model="queryDataNotice.noticeTitle"  placeholder="请输入消息标题"></el-input>
              <el-input v-model="queryDataNotice.noticeContent"  placeholder="请输入消息内容"></el-input>
              <el-date-picker v-model="queryDataNotice.timeBegin" type="date" value-format="yyyy-MM-dd" placeholder="起始时间" class="mr15"></el-date-picker>
              <el-date-picker v-model="queryDataNotice.timeEnd" type="date" value-format="yyyy-MM-dd" placeholder="结束时间" class="mr15"></el-date-picker>
              <el-button type="primary" @click="clickQueryNotice">查询</el-button>
            </div>
          </div>
          <!-- search End -->
          <!-- 列表 -->
          <el-table :data="dataListNotice" class="mt15" :header-cell-style="{textAlign: 'center'}" :cell-style="{ textAlign: 'center' }">
            <el-table-column prop="id" label="序号" min-width="5%"></el-table-column>
            <el-table-column prop="noticeType" label="消息类型" min-width="10%">
              <template slot-scope="props">
                <span v-if="props.row.noticeType == 1">系统消息</span>
                <span v-if="props.row.noticeType == 2">活动消息</span>
              </template>
            </el-table-column>
            <el-table-column prop="noticeTitle" label="消息标题" min-width="20%"></el-table-column>
            <el-table-column prop="noticeContent" label="消息内容" min-width="35%"></el-table-column>
            <el-table-column prop="createTime" label="创建时间" min-width="15%"></el-table-column>
            <el-table-column prop="Operation" label="操作" min-width="15%">
              <template slot-scope="scope">
                <el-tooltip class="item" effect="dark" content="发送" placement="top" :enterable="false">
                  <el-link :underline="false" type="danger" icon="el-icon-s-promotion" @click="ClickSendNotice(scope.row)"></el-link>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页 -->
          <div class="mt20">
            <el-pagination
              @size-change="handleSizeChangeNotice"
              @current-change="handleCurrentChangeNotice"
              :current-page="page_noNotice"
              :page-sizes="[5, 10, 15, 20]"
              :page-size="page_sizeNotice"
              layout="prev, pager, next, sizes, jumper "
              :total="dataListNoticenum">
            </el-pagination>
          </div>
          <!-- 分页 End -->
        </div>
        <!-- Right End -->
      </div>
    </el-dialog>
    <!-- 发送通知 End -->

  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
import WebTrainPlanLog from '@/componentsSubVue/WebTrainPlanLog.vue'
import WebDietaryPlanExecuteLog from '@/componentsSubVue/WebDietaryPlanExecuteLog.vue'
import WebBodyFatScalesLog from '@/componentsSubVue/WebBodyFatScalesLog.vue'
import WebCaloriesStatisticalLog from '@/componentsSubVue/WebCaloriesStatisticalLog.vue'
import WebTwoTrainReport from '@/componentsSubVue/WebTwoTrainReport.vue'
import WebTwoTrainPlanMy from '@/componentsSubVue/WebTwoTrainPlanMy.vue'
import WebTwoNoticeNeedRead from '@/componentsSubVue/WebTwoNoticeNeedRead.vue'
Vue.use(VueAxios, axios)

export default {
  components: {
    WebTrainPlanLog,
    WebDietaryPlanExecuteLog,
    WebBodyFatScalesLog,
    WebCaloriesStatisticalLog,
    WebTwoTrainReport,
    WebTwoTrainPlanMy,
    WebTwoNoticeNeedRead
  },
  data () {
    return {
      activeName: 'first',
      formLabelWidth: '120px',
      queryData: {
        account: '',
        nickName: '',
        slogan: '',
        sex: '0'
      },
      // 列表
      dataList: [],
      dataListnum: 0,
      page_no: 1,
      page_size: 5,
      // 编辑
      dialogEdit: false,
      editData: {
        editId: '',
        nickName: '',
        headimgurl: '',
        height: '',
        weight: '',
        age: '',
        sex: '',
        birthday: '',
        slogan: ''
      },
      // 消息
      dialogNotice: false,
      noticeData: {
        userid: '',
        noticeId: ''
      },
      allowChangeTab: false,
      multipleSelection: [],
      dialogNoticeTitle:'通知单个用户',
      queryDataNotice: {
        noticeType: '0',
        noticeTitle: '',
        noticeContent: '',
        timeBegin: '',
        timeEnd: ''
      },
      dataListNotice: [],
      dataListNoticenum: 0,
      page_noNotice: 1,
      page_sizeNotice: 5,
    }
  },
  mounted () {
    this.TerminalUserList()
    this.TerminalUserNum()
    this.NoticeList()
    this.NoticeNum()
  },
  methods: {
    BackToFirst (val) {
      this.activeName = 'first'
    },
    handleSizeChange (val) {
      this.page_size = val
      this.TerminalUserList()
      this.TerminalUserNum()
    },
    handleCurrentChange (val) {
      this.page_no = val
      this.TerminalUserList()
      this.TerminalUserNum()
    },
    beforeTabLeave(activeName, oldActiveName) {
      if (!this.allowChangeTab && activeName !== "first" && activeName !== "five") {
        this.$message.warning('禁止点击');
        return false;
      }
      this.allowChangeTab = false;
      return true;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      console.log(this.multipleSelection)
    },
    clickQuery () {
      this.page_no = 1
      this.TerminalUserList()
      this.TerminalUserNum()
    },
    clickQueryReset () {
      this.queryData.account = ''
      this.queryData.nickName = ''
      this.queryData.slogan = ''
      this.queryData.sex = '0'
      this.clickQuery()
    },
    clickNoticeSelect(){
      //必须勾选
      var useridList = []
      for (let element of this.multipleSelection) {
        useridList.push(element.id)
      }
      var userid = useridList.join(';');
      if(userid == ''){
        this.$message.warning('请至少勾选1个终端用户');
        return;
      }

      this.dialogNotice = true
      this.dialogNoticeTitle = '通知勾选用户'
      this.noticeData.userid = userid
      this.noticeData.noticeId = ''
    },
    clickNoticeAll(){
      this.dialogNotice = true
      this.dialogNoticeTitle = '通知所有用户'
      this.noticeData.userid = '0'
      this.noticeData.noticeId = ''
    },
    clickdialogNotice (row) {
      this.dialogNotice = true
      this.dialogNoticeTitle = '通知单个用户'
      this.noticeData.userid = row.id
      this.noticeData.noticeId = ''
    },
    clickdialogEdit (row) {
      this.dialogEdit = true
      this.editData.editId = row.id
      this.editData.nickName = row.nickName
      this.editData.headimgurl = row.headimgurl
      this.editData.height = row.height
      this.editData.weight = row.weight
      this.editData.age = row.age
      this.editData.sex = row.sex.toString()
      this.editData.birthday = row.birthday
      this.editData.slogan = row.slogan
    },
    //
    handleSizeChangeNotice (val) {
      this.page_sizeNotice = val
      this.NoticeList()
      this.NoticeNum()
    },
    handleCurrentChangeNotice (val) {
      this.page_noNotice = val
      this.NoticeList()
      this.NoticeNum()
    },
    clickQueryNotice () {
      this.page_noNotice = 1
      this.NoticeList()
      this.NoticeNum()
    },
    ClickSendNotice(row){
      this.$confirm('是否确定发送此消息?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.noticeData.noticeId = row.id
        this.NoticeNeedReadInsert()
      })
    },
    //
    gotoWebTrainPlanLog(row){
      this.allowChangeTab = true;
      this.activeName = 'second'
      this.$refs.SubVuesecond.LoadData(row)
    },
    gotoWebDietaryPlanExecute(row){
      this.allowChangeTab = true;
      this.activeName = 'three'
      this.$refs.SubVuethree.LoadData(row)
    },
    gotoWebBodyFatScalesLog(row){
      this.allowChangeTab = true;
      this.activeName = 'four'
      this.$refs.SubVuefour.LoadData(row)
    },
    gotoWebCaloriesStatisticalLog(row){
      this.allowChangeTab = true;
      this.activeName = 'five'
      this.$refs.SubVuefive.LoadData(row)
    },
    gotoWebTwoTrainReport(row){
      this.allowChangeTab = true;
      this.activeName = 'six'
      this.$refs.SubVuesix.LoadData(row)
    },
    gotoWebTwoTrainPlanMy(row){
      this.allowChangeTab = true;
      this.activeName = 'seven'
      this.$refs.SubVueseven.LoadData(row)
    },
    TerminalUserList: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.account = that.queryData.account
      data.nickName = that.queryData.nickName
      data.slogan = that.queryData.slogan
      data.sex = that.queryData.sex
      data.pageNo = that.page_no
      data.pageSize = that.page_size
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_TerminalUserList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.code === 1) {
            that.dataList = response.data.data
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    TerminalUserNum: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.account = that.queryData.account
      data.nickName = that.queryData.nickName
      data.slogan = that.queryData.slogan
      data.sex = that.queryData.sex
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_TerminalUserNum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.code === 1) {
            that.dataListnum = response.data.data
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    TerminalUserEdit: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.editId = that.editData.editId
      data.nickName = that.editData.nickName
      data.headimgurl = that.editData.headimgurl
      data.height = that.editData.height
      data.weight = that.editData.weight
      data.age = that.editData.age
      data.sex = that.editData.sex
      data.birthday = that.editData.birthday
      data.slogan = that.editData.slogan
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_TerminalUserEdit, Qs.stringify(data))
        .then(function (response) {
          that.dialogEdit = false
          Vue.prototype.FunRemindOnlyError(response.data)
          if (response.data.code === 1) {
            that.TerminalUserList()
            that.TerminalUserNum()
          }
        })
        .catch(function (error) {
          console.log(error)
          that.dialogEdit = false
        })
    },
    NoticeNeedReadInsert: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.userid = that.noticeData.userid
      data.noticeId = that.noticeData.noticeId
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_NoticeNeedReadInsert, Qs.stringify(data))
        .then(function (response) {
          // that.dialogNotice = false
          Vue.prototype.FunRemindAllways(response.data.msg)
        })
        .catch(function (error) {
          console.log(error)
          // that.dialogNotice = false
        })
    },
    NoticeList: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.noticeType = that.queryDataNotice.noticeType
      data.noticeTitle = that.queryDataNotice.noticeTitle
      data.noticeContent = that.queryDataNotice.noticeContent
      data.timeBegin = that.queryDataNotice.timeBegin
      data.timeEnd = that.queryDataNotice.timeEnd
      data.pageNo = that.page_noNotice
      data.pageSize = that.page_sizeNotice
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_NoticeList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.code === 1) {
            that.dataListNotice = response.data.data
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    NoticeNum: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.noticeType = that.queryDataNotice.noticeType
      data.noticeTitle = that.queryDataNotice.noticeTitle
      data.noticeContent = that.queryDataNotice.noticeContent
      data.timeBegin = that.queryDataNotice.timeBegin
      data.timeEnd = that.queryDataNotice.timeEnd
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_NoticeNum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.code === 1) {
            that.dataListNoticenum = response.data.data
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
  }
}
</script>

<style lang="less" scoped>
.search {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 15px;

  .el-input {
    width: 150px;
    margin-right: 15px;
  }

  .el-select{
    width: 150px;
    margin-right: 15px;
  }
}

@media ( max-width: 1440px) {
  .search {
    margin-top: 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .el-input {
      width: 120px;
      margin-right: 15px;
    }

    .el-select{
      margin-right: 15px;
      width: 130px;
    }
  }
}

.el-table thead {
  color: #666;
}

.el-form-item {
  margin-bottom: 16px;
}

.jingwei {
  margin-top: -8px;

  .zuobiao{
    margin-bottom: -10px;

    p {
      margin: 0;
    }

    & p:nth-child(2){
      margin-top: -10px;
    }
  }
}

.position{
  overflow: hidden;
  height: 332px;
  background: #f7f7f7;
}

/deep/ .el-table thead {
  color: #373735;
  font-weight: 500;
}

/deep/ .el-table th, .el-table tr {
  background: #eff3ff;
}

.newAdd /deep/ .el-dialog__footer {
  padding: 20px;
  text-align: center;
  border-top: 1px solid #f2f2f2;
}

.newAdd /deep/ .el-dialog__header {
  padding: 15px 20px 15px;
  background: #f6f6fa;
}
.newAdd /deep/ .el-dialog__headerbtn {
  top: 20px;
}

.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}

.addUser_body{
  padding: 0 46px 0 30px;
}

/deep/ .el-button--primary {
  color: #FFF;
  background-color: #4976ff;
  border-color: #4976ff;
}

/deep/ .el-button--primary.is-plain {
  color: #4976ff;
  background: #eff3ff;
  border-color: #4976ff;
}

// 圆角处理
/deep/ thead tr th:nth-child(1) {
  border-radius: 10px 0 0 0;
}
/deep/ thead tr th:nth-last-child(2) {
  border-radius: 0 10px 0 0;
}
</style>

<style scoped>
::v-deep .el-tabs__content {
  padding: 5px;
}
</style>
